import { Box, Button, List, Link, ListItem, ListItemText, Modal, TextField, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../../contexts/user.context';
import { fetchUsers, LPUser, updateUser } from '../../../utils/firebase/firebase.utils';

const defaultEditUserFormFields = {
    id: '',
    displayName: '',
    email: '',
    advertiserId: '',
}

const modalStyle = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 6,
    '& .MuiTextField-root': { mb: 3, width: '100%', maxWidth: '420px' },
};

const Users: React.FC = () => {

    const { loginUser } = useContext(UserContext)
    const [users, setUsers] = useState<LPUser[]>([]);
    const [openEditUserModal, setOpenEditUserModal] = React.useState(false);
    const [userFormFields, setUserFormFields] = useState(defaultEditUserFormFields)
    const { id, displayName, email, advertiserId } = userFormFields

    const navigate = useNavigate();
    const handleOpen = () => setOpenEditUserModal(true);
    const handleClose = () => setOpenEditUserModal(false);

    const resetFormFields = () => {
        setUserFormFields(defaultEditUserFormFields)
    }

    function getUsers() {
        const userList = fetchUsers();
        userList.then(users => {
            const sortedUsers = users.sort((a: LPUser, b: LPUser) =>
                a.displayName.toLowerCase().localeCompare(b.displayName.toLowerCase())
            );
            setUsers(sortedUsers);
        });
    }

    function editUser(user: LPUser) {
        handleOpen();
        console.log(`Editing user with id: ${user.id}`);
        setUserFormFields(user);
    }

    const handleLoginAsUser = (user: LPUser) => {
        if (!user.advertiserId) {
            console.error('User does not have an advertiserId');
            alert('User does not have an advertiserId');
            return;
        }
        loginUser(user.advertiserId);
        navigate('/');
    }

    useEffect(() => {
        getUsers();
    }, []);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target
        setUserFormFields({ ...userFormFields, [name]: value })
    }

    const hanldeUpdateUser = () => {
        console.log('updating user...');
        console.log(userFormFields);
        updateUser(userFormFields).then((result) => {
            if (result.success) {
                console.log('User updated successfully!');
                handleClose();
                resetFormFields();
                getUsers();
            }
        }).catch((error) => {
            console.error('Error updating user:', error);
        });
    };

    return (
        <React.Fragment>
            <h1>Users</h1>
            <List sx={{ p: 1, width: '100%', bgcolor: 'background.paper' }}>
                {users.map(user => (
                    <ListItem key={user.id}>
                        <ListItemText primary={user.displayName} secondary={user.email} />
                        <Link
                            sx={{ padding: '0 15px', cursor: 'pointer' }}
                            onClick={() => {
                                editUser(user);
                            }}>Edit</Link>
                        <Link
                            sx={{ cursor: 'pointer' }}
                            onClick={() => {
                                handleLoginAsUser(user);
                            }}>Login as user</Link>
                    </ListItem>
                ))}
            </List>
            <Modal
                open={openEditUserModal}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box
                    component="form"
                    noValidate
                    autoComplete="off"
                    sx={modalStyle}>

                    <Typography variant='h3'>Edit User</Typography>
                    <br />
                    <br />
                    <div>
                        <TextField
                            required
                            id="displayName"
                            name="displayName"
                            label="Name"
                            type="text"
                            autoComplete="name"
                            onChange={handleChange}
                            value={displayName}
                        />
                    </div>
                    <div style={{ display: "none" }}>
                        <TextField
                            required
                            id="email"
                            name="email"
                            label="Email"
                            type="email"
                            autoComplete="email"
                            onChange={handleChange}
                            value={email}
                        />
                    </div>

                    <div>
                        <TextField
                            required
                            id="advertiserId"
                            label="LeadsPedia Advetrtiser Id"
                            name="advertiserId"
                            type="text"
                            onChange={handleChange}
                            value={advertiserId}
                        />
                    </div>

                    <Button variant="contained" onClick={hanldeUpdateUser}>Submit</Button>
                    <Button onClick={handleClose}>Close</Button>

                </Box>
            </Modal>
        </React.Fragment>
    );
};

export default Users;